export const CookieNames = {
  SECONDARY_SITE: 'secondary_site',
};
